import { useTranslation } from "react-i18next";
import { Building2 } from "lucide-react";
import { DetailCard, DetailRow } from "./DetailCard";
import { fmtDate } from "./detailFmt";
import { localName } from "../../../lib/localName";

// معلومات المورد + تاريخ التسليم المتوقع.
export const DetailSupplier = ({ doc }) => {
  const { t, i18n } = useTranslation();
  const sup = doc.supplier || {};
  const name = localName(sup, t("purchases.internal"));
  return (
    <DetailCard tid="section-supplier" icon={Building2}
                title={t("purchases.podetail.supplierInfo")}>
      <DetailRow tid="row-supplier-name"
                 label={t("purchases.podetail.supplierName")} value={name} />
      {doc.needed_by ? (
        <DetailRow tid="row-needed-by"
                   label={t("purchases.podetail.expectedDelivery")}
                   value={<span className="num font-mono">{fmtDate(doc.needed_by)}</span>} />
      ) : null}
    </DetailCard>
  );
};
